import * as ActionType from "./type";

const initialState = {
  vipRewards: [],
  dialog: false,
  dialogData: null,
};

export const vipRewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_VIP_REWARD:
      return {
        ...state,
        vipRewards: action.payload,
      };

    case ActionType.OPEN_DIALOGUE_VIP_REWARD:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };

    case ActionType.CLOSE_DIALOGUE_VIP_REWARD:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };
    case ActionType.CREATE_VIP_REWARD:
      const data = [action.payload, ...state.vipRewards];
      return {
        ...state,
        vipRewards: data,
      };

    case ActionType.UPDATE_VIP_REWARD:
      return {
        ...state,
        vipRewards: state.vipRewards.map((vipReward) => {
          if (vipReward._id === action.payload.id) return action.payload.data;
          else return vipReward;
        }),
      };

    case ActionType.DELETE_VIP_REWARD:
      return {
        ...state,
        vipRewards: state.vipRewards.filter(
          (data) => data._id !== action.payload && data
        ),
      };
    default:
      return state;
  }
};

export default vipRewardReducer;